export default "__VITE_ASSET__d5zjRi7Q__"